import styles from "./loadingRipples.module.css";

const RIPPLE_CYCLE_MS = 2400;

/** Figma `88960:41244` middle ring — shared center + linear pulse. */
const RIPPLE = {
  nodeId: "88960:41244",
  centerX: 196,
  centerY: 426,
  startSize: 200,
  endSize: 670.06,
  startScale: 200 / 670.06,
} as const;

const RIPPLE_WAVES = [
  { id: "first", delayMs: 0 },
  { id: "second", delayMs: RIPPLE_CYCLE_MS / 3 },
  { id: "third", delayMs: (RIPPLE_CYCLE_MS * 2) / 3 },
] as const;

const DEFAULT_RING_PEAK_OPACITY = 0.85;
const DEFAULT_RING_END_OPACITY = 0.22;
const DEFAULT_RING_REDUCED_OPACITY = 0.55;

export interface LoadingRipplesProps {
  playing?: boolean;
  /**
   * PC 等宽于 393 的 modal 内水平居中涟漪原点（默认按 H5 393px 帧 `centerX=196`）。
   */
  centerHorizontally?: boolean;
  /** 在容器内垂直居中涟漪原点（默认按 H5 393×852 帧 `centerY=426`）。 */
  centerVertically?: boolean;
  /** 覆盖默认 `centerY=426`（H5 393×852）；PC 674 弹窗需单独坐标。 */
  centerY?: number;
  /** 涟漪圆环峰值透明度；未传时默认 85%。 */
  ringPeakOpacity?: number;
}

const resolveRingOpacityVars = (ringPeakOpacity?: number) => {
  if (ringPeakOpacity == null) {
    return undefined;
  }

  const endOpacity =
    ringPeakOpacity * (DEFAULT_RING_END_OPACITY / DEFAULT_RING_PEAK_OPACITY);
  const reducedOpacity =
    ringPeakOpacity *
    (DEFAULT_RING_REDUCED_OPACITY / DEFAULT_RING_PEAK_OPACITY);

  return {
    ["--ripple-peak-opacity" as string]: String(ringPeakOpacity),
    ["--ripple-end-opacity" as string]: String(endOpacity),
    ["--ripple-reduced-opacity" as string]: String(reducedOpacity),
  };
};

export const LoadingRipples = ({
  playing = true,
  centerHorizontally = false,
  centerVertically = false,
  centerY = RIPPLE.centerY,
  ringPeakOpacity,
}: LoadingRipplesProps) => (
  <div
    className={styles.layer}
    data-testid="onboarding-loading-ripple-layer"
    data-figma-node-id="88963:41287"
  >
    {RIPPLE_WAVES.map((wave) => (
      <div
        key={wave.id}
        className={styles.ring}
        style={{
          left: centerHorizontally ? "50%" : RIPPLE.centerX,
          top: centerVertically ? "50%" : centerY,
          ["--ripple-cycle" as string]: `${RIPPLE_CYCLE_MS}ms`,
          ["--ripple-delay" as string]: `${wave.delayMs}ms`,
          ["--ripple-end-size" as string]: `${RIPPLE.endSize}px`,
          ["--ripple-start-scale" as string]: String(RIPPLE.startScale),
          ...resolveRingOpacityVars(ringPeakOpacity),
        }}
        data-testid={`onboarding-loading-ripple-${wave.id}`}
        data-figma-node-id={RIPPLE.nodeId}
        data-playing={playing ? "1" : "0"}
      />
    ))}
  </div>
);
